// Ad-specific ordering is local to this collection visit, never a catalog write.
window.theme = window.theme || {};
window.theme.CollectionFeatured = class {
  constructor(root) {
    this.root = root;
    this.cache = new Map();
    this.revision = 0;
  }

  cancel() {
    this.revision++;
    this.controller?.abort();
    this.placeholder?.remove();
    this.placeholder = null;
  }

  handle(url) {
    const handle = url.searchParams.get('featured_product') || '';
    const canonical = new URL(this.root.dataset.collectionUrl, url);
    if (url.pathname.replace(/\/$/, '') !== canonical.pathname.replace(/\/$/, '')) return '';
    if ([...url.searchParams.keys()].some(k => k.startsWith('filter.') || k === 'sort_by')) return '';
    return /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) ? handle : '';
  }

  async apply(url) {
    this.cancel();
    const revision = this.revision;
    const handle = this.handle(url);
    const grid = this.root.querySelector('[data-collection-grid]');
    if (!handle || !grid) return;
    this.root.querySelectorAll('[data-pagination] a').forEach(link => {
      const next = new URL(link.href, url);
      next.searchParams.set('featured_product', handle);
      link.href = next.href;
    });
    const firstPage = !url.searchParams.has('page') || url.searchParams.get('page') === '1';
    const existing = [...grid.children].find(el => el.dataset.productHandle === handle);
    if (existing) {
      if (existing.dataset.productAvailable !== 'true') return;
      if (firstPage) grid.prepend(existing);
      else existing.remove(); // This item belongs to the first page of this ad visit.
      this.cache.set(handle, existing.cloneNode(true));
      return;
    }
    // Later pages never need to insert the advertised item again.
    if (!firstPage) return;
    const controller = this.controller = new AbortController();
    const placeholder = document.createElement('div');
    placeholder.className = 'ad-featured-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    this.placeholder = placeholder;
    grid.prepend(placeholder);
    const timeout = setTimeout(() => controller.abort(), 4500);
    try {
      let card = this.cache.get(handle);
      if (!card) {
        const endpoint = new URL(`${this.root.dataset.productBase}${encodeURIComponent(handle)}`, url);
        if (endpoint.origin !== url.origin) throw new Error('Unexpected product origin');
        endpoint.searchParams.set('view', 'ad-card');
        const response = await fetch(endpoint.href, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const wrapper = doc.querySelector('[data-ad-product]');
        const member = wrapper?.dataset.adCollections.split(',').includes(this.root.dataset.collectionHandle);
        if (wrapper?.dataset.adProduct !== handle || (!member && this.root.dataset.collectionHandle !== 'all')) return;
        card = wrapper.querySelector('[data-product-handle]');
        if (!card || card.dataset.productHandle !== handle || card.dataset.productAvailable !== 'true') return;
        this.cache.set(handle, card.cloneNode(true));
      }
      if (controller.signal.aborted || revision !== this.revision || !grid.isConnected) return;
      const copy = card.cloneNode(true);
      copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      placeholder.replaceWith(copy);
      window.wishlist?.sync?.();
      window.theme.reconvertPrices?.();
    } catch {
      // Invalid, unavailable or slow ad targets leave the native collection usable.
    } finally {
      clearTimeout(timeout);
      placeholder.remove();
      if (this.placeholder === placeholder) this.placeholder = null;
    }
  }
};
